import * as React from "react";
function SvgText(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M25.7 27h-8.4v-1.1l1.9-.3c.8-.2 1.1-.3 1.1-.6v-.3l-.1-.4-1.8-4.3h-7.2l-.5 1.4-.5 1.4-.3 1.2-.1.5c0 .3.2.6.7.8s1.3.4 2.4.5V27H4.3v-1.1l1.1-.2 1-.3c.4-.2.7-.5 1-.9l.7-1.2 3.4-8.2L15.3 6h2.9l4.5 11.2 2.8 6.8.3.6V0h2v32h-2v-5zm-7.9-8.4l-3-7.5-3 7.5h6z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgText);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
